import widgetArea from '../widget/widget-area'
import widget from '../widget/widget'

import htmlWidget from '../widgets/general/html'
import inlineImageWidget from '../widgets/general/inline-image'
import inlineVideoWidget from '../widgets/general/inline-video'
import textWidget from '../widgets/general/text'
import blockquoteWidget from '../widgets/general/blockquote'
import podcastWidget from '../widgets/general/podcast'
import paginatedListWidget from '../widgets/general/paginated-list'
import keyFactsWidget from '../widgets/general/key-facts'
import tweetWidget from '../widgets/general/tweet'

const widgets = [
  widget(),
  htmlWidget(),
  inlineImageWidget(),
  inlineVideoWidget(),
  textWidget(),
  blockquoteWidget(),
  podcastWidget(),
  paginatedListWidget(),
  keyFactsWidget(),
  tweetWidget()
]

const createQuery = () => `
  body {
    ${widgetArea(widgets)}
  }
`
export default createQuery
